<template>
	
  <div class="home">
	 <Bar />
   <div class="home-ct">
<div class="login">
	<div class="login-r1">
	<div class="re-tit">
		<h4>登入</h4>
		
		<p>為了新增購物體驗，加强了網上商城平臺。</p>
	</div>

	<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"  label-position="top" class="demo-ruleForm" size="mini">
	
			
	  <el-form-item label="Email" prop="email">
	    <el-input v-model="ruleForm.email"></el-input>
	  </el-form-item>

	  <el-form-item label="密碼" prop="password">
	    <el-input v-model="ruleForm.password" show-password></el-input>
	  </el-form-item>
	<router-link to="/repa">忘記密碼?</router-link>
	<div class="h-button" @click="submitForm('ruleForm')">登入</div>
	  </el-form-item>
	</el-form>
	</div>
	<div class="login-r2">
		
		
		<div class="re-tit login-r3">
			<h4>創建帳戶</h4>
			
			<p>有了更多的管道來解鎖令人興奮的特權，這是您的所有訪問通行證獨家獎勵。</p>
				<div class="h-button"><router-link to="register">創建帳戶</router-link></div>
		</div>
	</div>
	<div class="clear"></div>
</div>
   </div>
   <Sim />
   <Place />
    </div>
</template>
<script>

import Bar from '@/components/bar/bar'
import Place from '@/components/place/place'
import Sim from '@/components/sim/sim'

export default {
  components: {

	Bar,Place,Sim
  },
  data() {
    return {
            ruleForm: {
				email:'',
				password:''
			
                  },
                  rules: {
					
					  email: [
					    { required: true, message: '請輸入郵箱', trigger: 'blur' },
				],password: [
					    { required: true, message: '請輸入密碼', trigger: 'blur' },
				]
                 
                  }
          };
  },  mounted() {
	  this.id = this.$route.query.id

		this.sandMate();
		this.sandCase();
		},methods: {
			
		 submitForm(formName) {
			
			      
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		         this.$axios({
		           method: "post",
		           url: "service.php?action=users_emailLogin",
		           data: this.ruleForm,  
		         }).then((res) => {
		         	let data=res.data;
		         			
		         	if(data.code==1){
						
						localStorage.setItem("user", JSON.stringify(data.data));
			
		     this.$alert(data.message, '提示', {
		              confirmButtonText: '確認',
		              callback: action => {
		              this.$router.push({ path: "/" });	
		              }
		            });
		         		
		         	}else{  
						this.$message.error(data.message);
						      
					}
		          
		         });
				 
				 
		          } else {
		           
		            return false;
		          }
		        });
		      },
		      resetForm(formName) {
		        this.$refs[formName].resetFields();
		      }
		}
};
</script>
<style lang="scss" scoped>
	
	.h-button{
			text-align: center;
			cursor: pointer;
			width: 185px;
			padding: 0 50px;
			height: 50px;
			line-height: 50px;
			background: #000;
			color: #FFFFFF;
			margin-top: 30px;
		
		}
		.h-button:hover{
			background-color: #333333;
		}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			font-size: 14px;
			h4{
				font-size: 26px;
			}
			margin-bottom: 20px;
		}
	}	
.login-r1{
	width:500px;
	float: left;
	padding: 50px;
	border-right: 1px dotted #000000;
}
.login-r2{
	width:490px;

	padding: 50px;
	float: left;

}
</style>